var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.type, 'pill']},[_c('div',{staticClass:"dot"}),_vm._v(_vm._s(_vm.statusText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }